import { Component, output, ChangeDetectionStrategy } from '@angular/core';
import { InputComponent } from '../input/input.component';

@Component({
    selector: 'app-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SelectComponent extends InputComponent {
    change = output<any>();

    public onSelect(event: any) {
        this.change.emit(event);
    }
}
